import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import templateServices from '../../services/TemplateServices';
import { autorun } from 'mobx';
import _ from 'lodash';

const container = 'bodyContainer';
const position = 'bottomMainContainer';
const masterBodyLayout = 'masterBodyLayout';

@inject('LayoutTemplateStore')
@observer
class BottomMainComponent extends Component {
  constructor(props) {
		super(props)
    let dataComps = []

    dataComps = templateServices.listDataCompsByContainerPosition(this.props.LayoutTemplateStore, container, position, masterBodyLayout);
    this.state = {
      comps: templateServices.listComponentsByDataNoGrid(dataComps) || (<div></div>),
      isUseMasterLayout: true
    }   
  }

  componentDidMount() {
    this.autorun = autorun(() => {
      let { isUseMasterLayout, currentViewContainer } = this.props.LayoutTemplateStore;
      if (currentViewContainer === 'asiaView') {
        this.renderBottomMainToCurrentContainer();
      } else if (this.state.isUseMasterLayout !== isUseMasterLayout) {
        let dataComps = [];
        if (isUseMasterLayout) {
          dataComps = templateServices.listDataCompsByContainerPosition(this.props.LayoutTemplateStore, container, position, masterBodyLayout);
        } else {
          dataComps = templateServices.listDataCompsByContainerPosition(this.props.LayoutTemplateStore, container, position);
        }

        this.setState({
          comps: templateServices.listComponentsByDataNoGrid(dataComps) || ( <div> </div>),
          isUseMasterLayout: isUseMasterLayout
        }); 
      }
    });
  }

  /**
   * Hanlde getting data to the bottom Main components
   */
  renderBottomMainToCurrentContainer() {
    const { isUseMasterLayout } = this.props.LayoutTemplateStore;
    // Get current components to the container
    let dataComps = templateServices.listDataCompsByContainerPosition(this.props.LayoutTemplateStore, container, position);
    // If the current container has been defined bottom Main, it will be used current data components instead of the master layout
    if (_.isEmpty(dataComps) && isUseMasterLayout) {
      dataComps = templateServices.listDataCompsByContainerPosition(this.props.LayoutTemplateStore, container, position, masterBodyLayout);
    }

    this.setState({
      comps: templateServices.listComponentsByDataNoGrid(dataComps) || (<div> </div>),
      isUseMasterLayout: isUseMasterLayout
    });
  }
  
  componentWillUnmount() {
    this.autorun();
  }

  render() {
    return (
      <div id ="bottom-main-container" className={'bottom-main-container ' + this.props.className}>
        {this.state.comps}
     </div>
    );
  }
}

export default BottomMainComponent;



// WEBPACK FOOTER //
// ./src/app/components/BottomMainComponent/index.js